<template>
  <div class="login">
	 <p class="loginTit">欢迎使用 一鸣 在线音乐系统</p>
    <div class="registerForm">
		<div class="logo">
			<img src="../assets/inm_logo.png" class="inmLogoRegister" />
		</div>
		<div class="username">
			<div class="userTxt">店铺编号</div>
			<input class="user" v-model="shopCode" placeholder="请输入9位长编码" />
		</div>
		<div class="username">
			<div class="userTxt">店铺地址</div>
			<input class="userhalf" v-model="province" placeholder="请输入省" />
			<div class="splitTxt">省</div>
			<input class="userhalf" v-model="city" placeholder="请输入市" />
			<div class="splitTxt">市</div>
		</div>
		<div class="username">
			
			<input class="userhalf2" v-model="road" placeholder="请输入路" />
			<div class="splitTxt">路</div>
			<input class="userhalf2" v-model="houseno" placeholder="请输入号" />
			<div class="splitTxt">号</div>
			<input class="userhalf2" v-model="detailInfo" placeholder="详细信息" />
		</div>
		<div class="username">
			<div class="userTxt">手机类型</div>
			<select class="user font16" v-model="mobileType">
			  <option value="1">800自媒体手机（推荐）</option>
			  <option value="2">店主手机</option>
			  <option value="3">其它手机</option>
			</select>
		</div>
		<div class="username" v-if="mobileType == 3||mobileType == 2">
			<div class="userTxt">用户姓名</div>
			<input class="user" v-model="name" placeholder="请输入店主姓名" />
		</div>
		<div class="username">
			<div class="userTxt">手机号码</div>
			<input class="user" v-model="mobile" placeholder="请输入手机号" />
		</div>
		<div class="password">
			<div class="userTxt">登录密码</div>
			<input class="passwordInput" autocomplete="new-password" v-model="password" type="password" placeholder="请输入6位以上密码" />
		</div>
		<div class="password">
			<div class="userTxt">确认密码</div>
			<input class="passwordInput" autocomplete="new-password" v-model="password2" type="password" placeholder="请再次输入密码" />
		</div>
		
		
		
		<div class="loginBtn" @click="handleRegion">
			注       册
		</div>
		<div class="tips">
			<p class="tipTit">注:</p>
			<p class="tiptxt"><span class="xh">*</span>一店一账号，一账号仅能一店使用。</p>
			<p class="tiptxt"><span class="xh">*</span>若需解绑手机号码，请联系当地品牌经理。</p>
			<p class="tiptxt"><span class="xh">*</span>若无法登陆，请重置密码，仍无法登陆的请联系当地品牌经理。</p>
		</div>
	</div>
  </div>
</template>

<script>
import { region } from '../request/api.js'
const FIXED_SMS_CODE = '666666'
export default {
  name: 'Register',
  data(){
	  return{
		  mobileType:'1',
		  province:'',
		  city:'',
		  road:'',
		  houseno:'',
		  shopCode:'',
		  mobile:'',
		  password:'',
		  name:'',
		  shopAddr:'',
		  detailInfo:'',
		  password2:''
	  }
  },
  components: {
    
  },
  methods:{
	 async handleRegion(){
		
		 if(!this.shopCode||!this.mobile||!this.password||!this.province||!this.city||!this.road|!this.houseno){
			 this.toast('信息填写不完整')
			 return;
		 }
		 if(this.password.length<6){
			  this.toast('密码强度不够')
			   return;
		 }
		 if(this.password2!=this.password){
		  this.toast('两次密码输入不一致')
		   return;
		 }
		 if(this.shopCode.length != 9){
		  this.toast('店铺编号长度不合规，请输入9位编号')
		   return;
		 }
		 
		 
		const res = await region({
			  shopCode:this.shopCode,
			  mobile:this.mobile,
			  regionCode:FIXED_SMS_CODE,
			  password:this.password,
			  name:this.name,
			  shopAddr:this.shopAddr,
			  province:this.province,
			  city:this.city,
			  road:this.road,
			  houseno:this.houseno,
			  detailInfo:this.detailInfo,
			  mobileType:this.mobileType
		  }).then(res => {
			  if(res.code == 0){
				this.toast('注册成功');
				this.$router.push({
				     path: '/login',
				 })
			  }
			   
		  })
	  }
  }
}
</script>
